import * as React from 'react';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import SalesHeader from '~/apps/pos/mobile/components/sales/SaleHeader';
import PageMobileWrapper from '~/common/elements/mobile/PageMobileWrapper';
import BodyWrapper from '~/common/elements/mobile/BodyWrapper';
import FooterWrapper from '~/common/elements/mobile/FooterWrapper';
import HistoryHelp from '~/apps/pos/mobile/components/sales/HistoryHelp';
import HistoryMenu from '~/apps/pos/mobile/components/sales/HistoryMenu';
import PaginateSimple from '~/common/components/PaginateSimple'
import Button from '~/common/elements/mobile/Button';
import { getSaleList, setSaleCurrentPage } from '~/apps/pos/shared/actions/sales';
import { getLocationById } from '~/apps/shared/actions/locations';
import { navigate } from '~/router';
import { currency, date, timeStamp } from '~/lib/formatters';
import {
  getPaymentName,
  getSaleStatusName,
  getStatusClasses,
  isSaleDeletable,
  isSaleEditable,
} from '~/apps/pos/shared/services/helpers';
import { logout } from '~/apps/shared/actions/auth';
import { getAdditionalFieldByOrgId } from '~/apps/pos/shared/actions/additionalFields';
import { buttonSize, buttonStyle, icons } from '~/common/elements/mobile/consts';
import { defaultTablePageSize } from '~/common/components/consts';
import SalesFilter from "~/apps/pos/mobile/containers/sales/SalesFilter";
import {createRouteNodeSelector} from "redux-router5";
import {parseSaleStatusFilter} from "~/apps/pos/shared/services/qsfilter";
import {saleGetListParamsURL} from "~/apps/pos/models";
import SaleHistoryDesktopTable from "~/apps/pos/mobile/components/sales/SaleHistoryDesktopTable";
import { getCompanyFieldLabel, getSaleNumber } from "~/apps/pos/helpers";
import { Features } from "~/apps/shared/consts";

class historyPages {
  static HISTORY = 0;

  static MENU = 1;
}

class SaleHistory extends React.Component<any, any> {
  private updateSalesInterval: NodeJS.Timeout;

  constructor(props) {
    super(props);

    this.onChangePage = this.onChangePage.bind(this);
    this.onFetchData = this.onFetchData.bind(this);
    this.renderGrid = this.renderGrid.bind(this);
    this.handleAction = this.handleAction.bind(this);

    this.state = {
      page: historyPages.HISTORY,
    };
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.sales.ui.currentPage !== this.props.sales.ui.currentPage) {
      this.onFetchData(this.props.sales.ui.currentPage);
    } else if (prevProps.filter && this.props.filter) {
      if (!_.isEqual(prevProps.filter, this.props.filter)) {
        this.props.dispatch(setSaleCurrentPage());
        this.onFetchData(0);
      }
    }
  };

  componentDidMount(): void {
    const { dispatch, auth: { currentUser: { locationId, organizationId } } } = this.props;

    dispatch(setSaleCurrentPage());
    this.onFetchData(0);
    dispatch(getAdditionalFieldByOrgId(organizationId));
    if (locationId) {
      dispatch(getLocationById(locationId));
    }

    this.updateSalesInterval = setInterval(() => {
      this.onFetchData(this.props.sales.ui.currentPage);
    }, 30000);
  }

  componentWillUnmount(): void {
    clearInterval(this.updateSalesInterval);
  }

  handleAction(actionKey, e) {
    if (e) e.preventDefault();

    switch (actionKey) {
      case 'new-sale':
        navigate('pos.mobile.createSale');
        break;

      case 'logout':
        const { dispatch } = this.props;

        dispatch(logout())
          .then(() => {
            navigate('login');
          });
        break;

      case 'to-history':
        this.setState({
          page: historyPages.HISTORY,
        });
        break;

      case 'on-click-left':
        this.setState({
          page: historyPages.MENU,
        });
        break;

      case 'on-click-right':
        navigate('pos.mobile.help')
        break;

      default :
        console.log(actionKey);
        break;
    }
  }

  onChangePage = (pageNum: null) => {
    const { dispatch } = this.props;

    dispatch(setSaleCurrentPage(pageNum));
  };

  onFetchData = (page) => {
    const { dispatch, filter } = this.props;

    const req = {
      offset: page * defaultTablePageSize,
      limit: defaultTablePageSize
    } as saleGetListParamsURL;

    if (filter) {
      if (filter.q) {
        req.q = filter.q;
      }
      if (filter.status) {
        req.status = filter.status;
      }
    }

    dispatch(getSaleList(req));
  };

  renderAdditionalFields = (dataItem) => {
    const { additionalFields } = this.props;
    if (!additionalFields || !additionalFields.ui || !additionalFields.ui.currentList) return null;
    const _fieldsConfig = additionalFields.ui.currentList.map(a => additionalFields.entities[a]);
    let columnAdditional: any = [];

    _fieldsConfig.forEach((config) => {
        if (config.showInTable) {
          const _name = !dataItem || !dataItem.additionalFields ? '-' : dataItem.additionalFields[config.name];

          columnAdditional.push(
            <div key={config.id} className="m__body__info__block">
              <div className="m__body__lbl">{config.name}</div>
              <div className="m__body__lbl__info">{_name}</div>
            </div>
          )
        }
      }
    );

    return columnAdditional;
  };

  renderHeadAdditionalFields = () => {
    const { additionalFields } = this.props;
    if (!additionalFields || !additionalFields.ui || !additionalFields.ui.currentList) return null;
    const _fieldsConfig = additionalFields.ui.currentList.map(a => additionalFields.entities[a]);
    let columnAdditional: any = [];

    _fieldsConfig.forEach((config) => {
        if (config.showInTable) {
          columnAdditional.push(
            <div key={config.id} className="m__table__head__item">{config.name}</div>
          )
        }
      }
    );

    return columnAdditional;
  };

  handleSaleEdit = (saleId) => {
    navigate('pos.mobile.editSale', { saleId });
  }

  handleSaleDelete = (saleId, filter) => {
    const {q, status} = filter;

    navigate('pos.mobile.deleteSale', { saleId, q, status });
  }

  handleSaleView = (saleId, filter) => {
    const {q, status} = filter;

    navigate('pos.mobile.view', { saleId, q, status });
  }

  renderGrid = () => {
    const { sales: { entities, ui: { currentList } }, filter, information: { entities: { features } } } = this.props;

    return (
      <div className="m__table__cont">
        <div className="m__table__head">
          <div className="m__table__head__item"><span className="hide--xsm">Sale </span>#</div>
          <div className="m__table__head__item">Date</div>
          <div className="m__table__head__item">Amount</div>
          <div className="m__table__head__item">Status</div>
          <div className="m__table__head__item"><span className="hide--xsm">Payment </span>Type</div>
          <div className="m__table__head__item">PO#</div>
          <div className="m__table__head__item">{getCompanyFieldLabel(features)}</div>
          {this.renderHeadAdditionalFields()}
          <div className="m__table__head__item" />
        </div>
        <div className="m__table__content">
          <div className="m__table__item__cont">
            {
              currentList.map((itemId, ind) => {
                const item = entities[itemId];

                return (
                  <div key={itemId + ind} className="m__table__item">
                    <div className="m__body__info__block">
                      <div className="m__body__lbl">Sale #</div>
                      <div className="m__body__lbl__info">{getSaleNumber(item, features)}</div>
                    </div>
                    <div className="m__body__info__block">
                      <div className="m__body__lbl">Date</div>
                      <div className="m__body__lbl__info">{date(item.createdAt)}</div>
                    </div>
                    <div className="m__body__info__block">
                      <div className="m__body__lbl">Amount</div>
                      <div className="m__body__lbl__info">$ {currency(item.price)}</div>
                    </div>
                    <div className="m__body__info__block">
                      <div className="m__body__lbl">Status</div>
                      <div className="m__body__lbl__info">
                        <span className={getStatusClasses(item.status)} style={{ 'cursor': 'default' }}>{getSaleStatusName(item.status)}</span>
                      </div>
                    </div>
                    <div className="m__body__info__block">
                      <div className="m__body__lbl">Payment Type</div>
                      <div className="m__body__lbl__info">{getPaymentName(item.paymentType)}</div>
                    </div>
                    {!features.includes(Features.PO_NUMBER_NOT_REQUIRED) &&
                      <div className="m__body__info__block">
                        <div className="m__body__lbl">PO#</div>
                        <div className="m__body__lbl__info">{item.poNumber}</div>
                      </div>
                    }
                    <div className="m__body__info__block">
                      <div className="m__body__lbl">{getCompanyFieldLabel(features)}</div>
                      <div className="m__body__lbl__info">{item.company}</div>
                    </div>
                    {features.includes(Features.ADD_COMPLETED_AT) && !!item.completedAt &&
                      <div className="m__body__info__block">
                        <div className="m__body__lbl">Completed At</div>
                        <div className="m__body__lbl__info">{timeStamp(item.completedAt)}</div>
                      </div>
                    }
                    {this.renderAdditionalFields(item)}
                    {features.includes(Features.ENABLE_NOT_FIELD_FOR_CLERKS) &&
                      <div className="m__body__info__block">
                        <div className="m__body__lbl">Note</div>
                        <div className="m__body__lbl__info">{item.description}</div>
                      </div>
                    }
                    <br/><br/>
                    <div className="m__body__info__block --withbtn">
                      {isSaleEditable(item.status, item.paymentType, item.paymentId) &&
                        <Button
                          title="Edit"
                          buttonStyle={buttonStyle.PRIM}
                          buttonSize={buttonSize.MD}
                          onClick={(actionKey, e) => {
                            e.preventDefault();
                            this.handleSaleEdit(item.id);
                          }}
                        />
                      }
                      <Button
                        title="Details"
                        buttonStyle={buttonStyle.LITE}
                        buttonSize={buttonSize.MD}
                        onClick={(actionKey, e) => {
                          e.preventDefault();
                          this.handleSaleView(item.id, filter);
                        }}
                      />
                      {isSaleDeletable(item.status, item.paymentType) &&
                        <Button
                          title="Delete"
                          buttonStyle={buttonStyle.WARN}
                          buttonSize={buttonSize.MD}
                          onClick={(actionKey, e) => {
                            e.preventDefault();
                            this.handleSaleDelete(item.id, filter);
                          }}
                        />
                      }
                    </div>
                  </div>
                )
              })
            }
          </div>
        </div>
      </div>
    )
  };

  render() {
    const { sales: { ui: { currentList, currentPage, loading }, entities }, additionalFields, isDesktop, filter, information } = this.props;
    const { page } = this.state;
    const hasFhiFeature = information.entities.features && information.entities.features.includes(Features.FHI);

    if (isDesktop) {
      const _sales = currentList ? currentList.map(u => entities[u]) : [];
      const _additionalFields = additionalFields && additionalFields.ui && additionalFields.ui.currentList
      && additionalFields.entities ? additionalFields.ui.currentList.map(a => additionalFields.entities[a]) : [];

      return (
        <SaleHistoryDesktopTable
          manual={true}
          loading={loading}
          page={currentPage}
          data={_sales}
          additionalFields={_additionalFields}
          onFetchData={() => {}}
          onEdit={this.handleSaleEdit}
          onDelete={this.handleSaleDelete}
          onView={this.handleSaleView}
          onPageChange={this.onChangePage}
          filter={filter}
          features={information.entities.features}
        />
      )
    }

    switch (page) {
      case historyPages.HISTORY:
        return (
          <PageMobileWrapper>
            <SalesHeader
              onHelp={this.handleAction}
              onBack={this.handleAction}
              title="History"
              isMain={false}
              iconLeft={icons.MENU}
            />
            <SalesFilter hasFhiFeature={hasFhiFeature} />
            <BodyWrapper className={`m__body--withtable ${hasFhiFeature ? "m__body--with-export" : ""}`}>
              {this.renderGrid()}
              <div className="ReactTable m__table__pagi">
                <PaginateSimple
                  page={currentPage}
                  data={currentList}
                  onPageChange={this.onChangePage}
                />
              </div>
            </BodyWrapper>
            <FooterWrapper className={hasFhiFeature && "--under-portal"}>
              <Button
                title="New Sale"
                actionKey="new-sale"
                buttonStyle={buttonStyle.SECN}
                buttonSize={buttonSize.LG}
                onClick={this.handleAction}
              />
            </FooterWrapper>
          </PageMobileWrapper>
        );
      case historyPages.MENU:
        return (
          <HistoryMenu
            onBack={this.handleAction}
            backActionKey={'to-history'}
            menuActions={this.handleAction}
          />
        );
    }
  }
}

const mapStateToProps = (state) => {
  const selector = createRouteNodeSelector('pos');
  const { route: { params } } = selector(state);

  const filter = parseSaleStatusFilter(params);
  return {
    auth: state.shared.auth,
    sales: state.pos.sales,
    additionalFields: state.pos.fields,
    information: state.shared.information,
    filter,
  }
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SaleHistory);
